import { OrderItemWithNonNullProduct, OrderWithProducts } from "../types";

const Order = {
  getProducts(order: OrderWithProducts): OrderItemWithNonNullProduct[] {
    return order.items.filter(({ product }) => !!product) as OrderItemWithNonNullProduct[];
  }
};

export default Order;
